import React from 'react';
import { Link } from 'react-router-dom';
import Velocity from 'velocity-animate';
import classNames from 'classnames';
import debounce from 'lodash/debounce';
import I18N from '../i18n';
import map from 'lodash/map';
import pickBy from 'lodash/pickBy';

class Navigation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isTop: true,
    };

    this.scrollPos = debounce(this.scrollPos, 10).bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.scrollPos);
  }

  scrollPos() {
    const scrollTop =
      window.pageYOffset !== undefined
        ? window.pageYOffset
        : (document.documentElement ||
            document.body.parentNode ||
            document.body).scrollTop;

    // console.log(scrollTop, !!(scrollTop <= 50));

    this.setState({
      isTop: !!(scrollTop <= 50),
    });
  }

  handleScroll(e) {
    const target = document.getElementById(e.target.hash.substr(1));

    e.preventDefault();
    e.stopPropagation();

    Velocity(target, 'scroll', {
      duration: 800,
      easing: 'ease-in-out',
      offset: 0,
    });
  }

  handleScrollTop() {
    Velocity(document.body, 'scroll', {
      duration: 800,
      easing: 'ease-in-out',
      offset: 0,
    });
  }

  render() {
    const pathname = this.props.location.pathname.replace(/^\/|\/$/g, '');
    const isHome = pathname === `${this.props.currentLang}`;

    const navLanguages = pickBy(I18N.languages, (value, key) => {
      return (key !== this.props.currentLang);
    });

    return (
      <nav
        className={classNames('site-nav', {
          'is-alt-color': this.props.altColor || false,
          'is-home': isHome,
        })}
      >
        <ul
          className={classNames('site-nav__items is-bottom', {
            'is-visible': this.state.isTop,
          })}
        >
          <li className="site-nav__item is-projects">
            <a href="#featured-projects" onClick={e => this.handleScroll(e)}>
              ↓<span className="sr-only">Projects</span>
            </a>
          </li>
          <li className="site-nav__item is-lang">
            {map(navLanguages, (lang, key) => <a href={`/${key}`}>{lang.label}</a>)}
          </li>
        </ul>
        <ul className="site-nav__items is-top">
          <li className="site-nav__item is-home">
            <Link to={`/${this.props.currentLang}`} onClick={e => this.handleScrollTop()}>
              Stéfanie Vermeersch
            </Link>
          </li>
          <li className="site-nav__item is-info">
            <a href="#site-footer" onClick={e => this.handleScroll(e)}>
              Info
            </a>
          </li>
        </ul>
      </nav>
    );
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Navigations.js